<template>
  <TaskList
    title="Financial Document"
    taskType="financial_document"
  >
  </TaskList>
</template>

<script>
import TaskList from '@/components/TaskList.vue';

export default {
  components: {
    TaskList
  },
}
</script>
